import React from 'react';
import {connect} from "react-redux";
import {load, load_available_assignees} from '../../actions/logbookAction';
import PageHeader from "../../components/elements/PageHeader";
import {translate} from "react-i18next";
import AddInformation from "./AddInformation";
import Information from "./Information";
import Task from "./Task";
import AddTask from "./AddTask";
import Select2 from "react-select2-wrapper";

class Logbook extends React.Component {

    state = {
        addInformation: false,
        addTask: false,
        searchInformation: '',
        searchTask: '',
        statusFilterTask: []
    };

    refreshTimeout = null;

    componentDidMount() {
        this.getData();
        this.props.load_available_assignees();
    }

    componentWillUnmount() {
        if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);
    }

    getData = (reload) => {
        let lastUpdatedAt = this.props.logbook.lastUpdatedAt;
        if(reload) lastUpdatedAt = 0;
        if(this.refreshTimeout) window.clearTimeout(this.refreshTimeout)
        this.props.load(lastUpdatedAt);
        this.refreshTimeout = window.setTimeout(() => {
            this.getData();
        }, 10000);
    };

    filterInformationSearch = (entry) => {
        let show = false;
        if (entry.message.toLowerCase().indexOf(this.state.searchInformation.toLowerCase()) !== -1) show = true;
        entry.comments.forEach((comment) => {
            if (comment.message.toLowerCase().indexOf(this.state.searchInformation.toLowerCase()) !== -1) show = true;
        });
        return show;
    };

    filterTaskSearch = (entry) => {
        let showByText = false;
        let showByStatus = false;
        if(this.state.searchTask.length > 0) {
            if (entry.message.toLowerCase().indexOf(this.state.searchTask.toLowerCase()) !== -1) showByText = true;
            entry.comments.forEach((comment) => {
                if (comment.message.toLowerCase().indexOf(this.state.searchTask.toLowerCase()) !== -1) showByText = true;
            });
        } else {
            showByText = true;
        }
        if (this.state.statusFilterTask.length > 0) {
            if(this.state.statusFilterTask.includes(entry.status) || (!entry.status && this.state.statusFilterTask.includes('NONE'))) showByStatus = true;
        } else {
            showByStatus = true;
        }
        return showByText && showByStatus;
    };

    render() {
        const {t, logbook} = this.props;

        return (
            <div className="Logbook">
                <PageHeader title={t('logbook.title')} loading={logbook.loading}/>
                <div className="row m-t m-b content-row">
                    <div className="col-md-6 entries-container">
                        <div className="white-bg p-sm flex-container">
                            <div className="entries-header">
                                <button className="btn btn-default pull-right"
                                        onClick={() => this.setState({addInformation: !this.state.addInformation})}>
                                    <i className={`fa fa-${this.state.addInformation ? 'close' : 'plus'}`}/>
                                </button>
                                <input type="text" className="form-control pull-right search m-r-sm"
                                       onChange={(e) => this.setState({searchInformation: e.target.value})}
                                       placeholder={`${t('default.search')}...`} value={this.state.searchInformation}/>
                                <h3>
                                    {t('logbook.informations')}
                                </h3>
                            </div>
                            <div className="entries">
                                {this.state.addInformation ? (
                                    <AddInformation handleClose={() => {
                                        this.setState({addInformation: false});
                                        this.getData(true);
                                    }}/>
                                ) : null}
                                {logbook.entries.filter((e) => e.type.name === 'INFO' && this.filterInformationSearch(e)).map((entry) => (
                                    <Information entry={entry} key={`ei-${entry.id}`} setSearchInformation={(val) => this.setState({searchInformation: val})}/>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 entries-container">
                        <div className="white-bg p-sm flex-container">
                            <div className="entries-header">
                                <button className="btn btn-default pull-right"
                                        onClick={() => this.setState({addTask: !this.state.addTask})}>
                                    <i className={`fa fa-${this.state.addTask ? 'close' : 'plus'}`}/>
                                </button>
                                <input type="text" className="form-control pull-right search m-r-sm"
                                       onChange={(e) => this.setState({searchTask: e.target.value})}
                                       placeholder={`${t('default.search')}...`} value={this.state.searchTask}/>
                                <Select2 multiple data={[
                                    {id: 'NONE', text: t('default.task.status.noneText')},
                                    {id: 'CREATED', text: t('default.task.status.created')},
                                    {id: 'IN_PROGRESS', text: t('default.task.status.inProgress')},
                                    {id: 'DONE', text: t('default.task.status.done')}
                                ]} value={this.state.statusFilterTask} onChange={(e) => this.setState({statusFilterTask: [...e.target.options].filter(({selected}) => selected).map(({value}) => value)})} options={{placeholder: t('logbook.stateFilter.placeholder')}} className="pull-right"/>
                                <h3>
                                    {t('logbook.tasks')}
                                </h3>
                            </div>
                            <div className="entries">
                                {this.state.addTask ? (
                                    <AddTask handleClose={() => {
                                        this.setState({addTask: false});
                                        this.getData(true);
                                    }}/>
                                ) : null}
                                {logbook.entries.filter((e) => e.type.name === 'TASK' && this.filterTaskSearch(e)).map((entry) => (
                                    <Task entry={entry} key={`ei-${entry.id}`} setSearchInformation={(val) => this.setState({searchTask: val})}/>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook
});

export default connect(mapStateToProps, {
    load, load_available_assignees
})(translate()(Logbook));
